<nav
  class="l-unshrink h-full bg-white"
  [class.is-rtl]="dir == 'rtl'"
  [class.is-ltr]="dir == 'ltr'"
>
  <ul
    class="h-full bg-white sidebar-nav"
    [class.mobile-nav-open]="isMobileNavOpen"
  >
    <header class="l-align-y navbar-table">
      <div class="bar-container">
        <a class="close-nav-btn" (click)="closeMobileNav()">
          <i class="fas fa-bars"></i>
        </a>
      </div>
    </header>

    <img class="logo" src="assets\img\brosh-online.svg" [title]="version" />

    <ng-container *ngFor="let tab of navList">
      <li
        *ngIf="!tab.isHidden"
        class="sidebar-li"
        [ngClass]="{ 'is-active': tab.isActive }"
      >
        <a
          [ngClass]="{
            'is-active': tab.isActive,
            'is-disabled': !isEnabled(tab)
          }"
          class="l-align-y sidebar-link"
          (click)="navigate(tab)"
        >
          <img *ngIf="tab.img" class="sidebar-icon-new" [src]="tab.img" />
          <i *ngIf="!tab.img" class="sidebar-icon-new fa fa-{{ tab.icon }}"></i>
          &nbsp;
          {{ tab.tabTitle | translate }}

          <span *ngIf="tab.badge" class="badge">{{ tab.badge }}</span>
        </a>
      </li>
    </ng-container>

    <button
      *ngIf="allowCreateOrder"
      class="t-button create-order"
      (click)="onCreateOrder()"
    >
      {{ "translate.rx.createNewOrder" | translate }}
    </button>
  </ul>
</nav>

<modal-popup
  [flexible]="true"
  [hideHeader]="true"
  (onClose)="selectClinicDisplay = false"
  [isOpen]="selectClinicDisplay"
>
  <section class="w-full">
    <header class="l-flex l-align-y l-align-spaceBetween">
      <h2 class="t-widgetTitle">
        {{ "translate.rx.selectClinic" | translate }}
      </h2>
      <i
        class="fas fa-times t-popupCloseIcon"
        (click)="selectClinicDisplay = false"
      ></i>
    </header>
    <hr />
  </section>

  <div class="body-container">
    <section class="w-full">
      <!--clinic-->
      <input-wrap
        label="{{ 'translate.general.clinic' | translate }}"
        [required]="true"
        cssClass="l-cell-spread"
      >
        <p-select
          class="t-input--colored"
          [options]="clinicList"
          [(ngModel)]="selectedClinic"
          [placeholder]="'translate.general.choose' | translate"
          [optionLabel]="'clinicDescr'"
          [dataKey]="'clinicId'"
          [filter]="true"
          [resetFilterOnHide]="true"
          appendTo="body"
          [virtualScroll]="true"
          [virtualScrollItemSize]="30"
        ></p-select>
      </input-wrap>
    </section>

    <div class="t-panel-cell t-buttonSet l-align-end">
      <button
        [disabled]="!selectedClinic"
        (click)="onClinicSelect()"
        class="t-button-outline"
      >
        {{ "translate.alert.continue" | translate }}
      </button>
    </div>
  </div>
</modal-popup>
